<template>
  <main>
    <div class="container-fluid p-0 mt-0">
      <section id="carousel" v-if="showCarousel && listaCarrosel && listaCarrosel.length">
        <carousel :per-page="1" :mouse-drag="true" :autoplay="true" :loop="true" :transition="1000">
          <slide v-for="(slide, index) of listaCarrosel" :key="index">
            <img @click="clickBanner(slide)" :src="slide.banner" style="width: 100%; object-fit: cover;"
              :class="{ 'cursor-pointer': slide.href || slide.url }" />
          </slide>
        </carousel>
      </section>
    </div>

    <div class="container-fluid mt-3" style="width: 100%;max-width: 1200px;" v-if="!this.loading">
      <div class="grid-pesquisa">
        <form class="input-group flex-nowrap" v-on:submit.prevent="pesquisarDescontos()">
          <input class="w-100 form-control-lg" aria-label="Large" type="search" placeholder="O que você procura?"
            v-model="search" />
          <button class="btn_selecionar item_produto pl-3 pr-3" style="border: none;font-size:1.2em">
            Pesquisar
          </button>
        </form>
      </div>
    </div>

    <div class="container-fluid mt-3" style="width: 100%;max-width: 1200px;">

      <div class="row mb-3 g-3 mt-5">
        <div class="col">
          <div class="row mt-3">
            <span class="col text-left">
              <h5><strong>Categorias</strong></h5>
            </span>
            <span class="col-2 text-center">
              <a href="#" @click="pesquisarPorCategoria('')">
                <i class="fa-solid fa-filter-circle-xmark icon"></i>
              </a>
            </span>

          </div>
          <div class="a-divider a-divider-break"></div>
        </div>
      </div>
      <div class="justify-content-center" v-if="this.categorias">
        <carousel :per-page="1" :perPageCustom="[
        [300, 3],
        [500, 5],
        [800, 6],
        [1200, 8]
      ]" :mouse-drag="true" :autoplay="false" :loop="true" :speed="500">
          <slide v-for="(item, index) of this.categorias" :key="index">
            <div>
              <div class="col text-center">
                <a href="#" @click="pesquisarPorCategoria(item.value)">
                  <img class=" rounded-circle circle-categoria" :src="item.url" />
                </a>
                <br />
                <span style="font-size:18px;">{{ item.nome }}</span>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
      <div class="row mb-3 g-3 mt-3">
        <div class="col-4">
          <select class="form-control  font-weight-bold" v-model="uf" @change="pesquisarDescontos()">
            <option value="">Localidade</option>
            <option value="AC">AC</option>
            <option value="AL">AL</option>
            <option value="AP">AP</option>
            <option value="AM">AM</option>
            <option value="BA">BA</option>
            <option value="CE">CE</option>
            <option value="DF">DF</option>
            <option value="ES">ES</option>
            <option value="GO">GO</option>
            <option value="MA">MA</option>
            <option value="MT">MT</option>
            <option value="MS">MS</option>
            <option value="MG">MG</option>
            <option value="PA">PA</option>
            <option value="PB">PB</option>
            <option value="PR">PR</option>
            <option value="PE">PE</option>
            <option value="PI">PI</option>
            <option value="RJ">RJ</option>
            <option value="RN">RN</option>
            <option value="RS">RS</option>
            <option value="RO">RO</option>
            <option value="RR">RR</option>
            <option value="SC">SC</option>
            <option value="SP">SP</option>
            <option value="SE">SE</option>
            <option value="TO">TO</option>
          </select>
        </div>
      </div>


      <div class="row m-3" v-if="erro">
        <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
          {{ erro }}
        </div>
      </div>
      <div class="products">
        <div class="caixa_produtos">
          <div class="lista_produtos">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-2" v-for="item of descontos" :key="item.id">
                <div class="item_produto item_semestral text-center mt-4" data-toggle="tooltip" data-placement="top"
                  :title="item.excerpt">

                  <div class="titulo_categoria ellipsis">
                    <div :style="{ 'background-image': urlImage(item.thumbnail_image_url) }">
                    </div>
                    <span class="justify-content-center">{{ item.discount }}</span>
                    <span v-if="item.linkAuth && item.planoId && item.codigoIntegracao">
                      <a class="btn_selecionar" @click="openBeneficio(item.linkAuth)">Ver Benefício</a>
                    </span>

                    <span v-else-if="item.planoId && !item.codigoIntegracao && atualizarDadosConta">
                      <a class="btn_selecionar" @click="atualizarItem(item)" data-bs-toggle="modal"
                        data-bs-target="#modalDadosUsuario">Ver Benefício</a>
                    </span>
                    <span v-else-if="item.planoId && !item.codigoIntegracao && !atualizarDadosConta">
                      <a class="btn_selecionar" @click="openBeneficioAtualizarConta(item)">Ver Benefício</a>
                    </span>
                    <span v-else>
                      <a class="btn_selecionar" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">Ver
                        Benefício</a>
                    </span>
                  </div>
                </div>
              </div>
              <a class="btn_selecionar d-none" ref="modalSemPlano" id="btnModalSemPlano" data-bs-toggle="modal"
                data-bs-target="#exampleModalCenter">Ver
                Benefício</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              <strong>
                Clube de desconto
              </strong>
            </h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <span>
                Você não possui um plano contratado, não fique de fora assine agora mesmo um dos nossos planos e tenha
                acesso aos descontos.
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" style="background-color:var(--cor-principal);" data-bs-dismiss="modal"
              @click="$router.push('/')">Assinar
              agora</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <UsuarioClubeBeneficioAtualizar v-if="atualizarDadosConta" :dadosConta="dadosConta" :clubeBeneficio="item">
    </UsuarioClubeBeneficioAtualizar>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>

import UsuarioClubeBeneficioAtualizar from "@/views/UsuarioClubeBeneficioAtualizar.vue";
import Loading from "@/components/Loading.vue";
import { APIService } from "../APIService";
const apiService = new APIService();


export default {
  name: "ClubeDesconto",
  components: { Loading, UsuarioClubeBeneficioAtualizar },
  data() {
    return {
      erro: "",
      loading: false,
      categoria: "",
      uf: "",
      pesquisa: "",
      search: "",
      descontos: null,
      categorias: [],
      showCarousel: true,
      listaCarrosel: [],
      ativacaoManual: null,
      item: null,
      dadosConta: null,
      atualizarDadosConta: false
    };
  },
  mounted() {
    if (this.$route.query.bearerTokenOneFan) {
      this.loading = true
      return;
    }

    this.categoria = this.$route.query.categoria;
    this.obterDados();
    this.pesquisarDescontos();
    this.carregarCategorias();
    window.addEventListener('resize', this.refreshCarousel)
    this.listaCarrosel = window.BANNER_CLUBE;
    this.$router.replace({
      query: {},
    });
  },
  destroyed() {
    window.removeEventListener('resize', this.refreshCarousel)
  },
  beforeUpdate() {
    this.atualizarDadosConta = this.verificarDadosAtualizados();
  },
  methods: {
    carregarCategorias() {
      this.loading = true;
      apiService
        .obeterCatgoriaDescontos()
        .then((res) => {
          this.categorias = res;
        })
        .catch(error => {
          this.erro = error.response.data.title;
          this.loading = false;
          window.scrollTo(0, 0);
        });

    },
    urlImage(imagemUrl) {
      return `url('${imagemUrl ||
        "https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png"}')`;
    },
    pesquisarPorCategoria(categoria) {
      this.categoria = categoria;
      this.pesquisarDescontos();
    },
    openBeneficio(url) {
      window.open(url, '_blank')
    },
    atualizarItem(item) {
      this.item = item;
    },
    openBeneficioAtualizarConta(item) {
      this.item = item;
      this.atualizarDadosAssinarPlano();
    },

    atualizarDadosAssinarPlano() {
      this.loading = true;

      var dados = {
        conta: { contaId: this.dadosConta.conta.contaId },
        pessoa: {
          id: this.dadosConta.pessoa.id,
          nome: this.dadosConta.nome  += this.dadosConta.sobreNome ? " "+this.dadosConta.sobreNome: "",
          cpf: this.dadosConta.pessoa.cpf,
          registroAssociacao1: this.dadosConta.pessoa.registroAssociacao1,
          telefone: this.dadosConta.pessoa.telefone,
          email: this.dadosConta.pessoa.email
        }
      }

      apiService
        .atualizarDadosClubeBeneficio(dados, this.item.id)
        .then((res) => {
          this.loading = false;

          if (res.linkAuth) {
            window.open(res.linkAuth, '_blank');
          } else {
            this.erro = 'ERRO AO ACESSAR BENEFÍCIO'
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.title
          ) {
            this.erro = error.response.data.title;
          }

          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    pesquisarDescontos() {
      this.loading = true;
      apiService
        .pesquisarDescontos(this.categoria, this.uf, this.search)
        .then((res) => {
          this.descontos = res;

          if (this.dadosConta) {
            this.loading = false;
          }
        })
        .catch(error => {
          this.erro = error.response.data.title;

          if (this.dadosConta) {
            this.loading = false;
          }

          window.scrollTo(0, 0);
        });
    },
    clickBanner(slide) {
      if (slide.href) {
        if (slide.idClube) {
          var clube = this.descontos.filter(o => o.linkAuth);
          if (clube && clube.length > 0) {
            const tokens = clube[0].linkAuth.split('accessToken=');

            if (tokens && tokens.length > 0) {
              window.open('#/servico/clube-desconto/' + slide.idClube + "?accessToken=" + tokens[1], '_blank')
            }
          } else {
            this.abrirModalSemPlano();
          }
        } else {
          if (!slide.href.includes("http")) {
            slide.href && this.$router.push(`/${slide.href}`)
            slide.url && window.open(slide.url, '_blank')
          } else {
            window.open(slide.href, '_blank')
          }
        }
      }
    },
    refreshCarousel() {
      this.showCarousel = false
      setTimeout(() => (this.showCarousel = true), 100)
    },
    abrirModalSemPlano() {
      document.getElementById("btnModalSemPlano").click();
    },
    obterDados() {
      this.loading = true;

      apiService
        .dadosApp()
        .then((res) => {
          this.dadosConta = res;
          this.dadosConta.nome = res.pessoa.nome.replace(/\s.+$/, "");
          if (/\s\S/.test(res.pessoa.nome)) {
            this.dadosConta.sobreNome = res.pessoa.nome.replace(this.dadosConta.nome + " ", "");
          } else {
            this.dadosConta.sobreNome = "";
          }
          this.dadosConta.telefone = res.pessoa.telefone ? res.pessoa.telefone.telefone : null;

          if (this.descontos) {
            this.loading = false;
          }

          if (apiService.validarCPF(res.pessoa.cpf)) {
            this.dadosConta.cpf = res.pessoa.cpf;
          } else {
            // this.dadosConta.matricula = res.pessoa.cpf;
          }

          this.atualizarDadosConta = this.verificarDadosAtualizados();
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.title
          ) {
            if (this.descontos) {
              this.erro = error.response.data.title;
            }
          }
          this.loading = false;

          window.scrollTo(0, 0);
        });
    },
    verificarDadosAtualizados() {
      this.atualizarDadosConta = true;

      if (this.dadosConta && this.dadosConta.pessoa) {
        if (this.dadosConta.pessoa.telefone && this.dadosConta.pessoa.email
          && (this.dadosConta.cpf || this.dadosConta.pessoa.registroAssociacao1)) {
          this.atualizarDadosConta = false;
          return false;
        }
      }
      return true;
    },
  }
};
</script>
<style scoped lang="scss">
.circle-categoria {
  background-color: var(--cor-secundaria);
  max-width: 65px;
}

.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  transition: 0.5s;
  color: var(--cor-secundaria);
  overflow: hidden;
}


.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid var(--cor-principal);
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }
}

.chamada_categoria {
  max-height: 100px;
}

.chamada_categoria h3 {
  font-weight: 400;
  margin-top: 0.2rem;
  font-size: 2em;
}

.chamada_categoria p {
  font-size: 1.2rem;
  padding: 0 1rem;
}

.chamada_categoria.cat_familia h3 {
  color: var(--cor-principal);
  font-size: 1.3rem;
  margin: 0 8px;
}

.chamada_categoria.cat_familia hr {
  border: 0;
  display: flex;
  flex: 1;
  background: var(--cor-secundaria);
  height: 2px;
  position: relative;
}

.chamada_categoria.cat_familia hr:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background: #01010100;
  background: -webkit-linear-gradient(left, #01010100, #ffffff);
  background: -moz-linear-gradient(left, #01010100, #ffffff);
  background: linear-gradient(to right, #01010100, #ffffff);
  width: 100%;
  height: 100%;
}

.chamada_categoria.cat_atleta h3 {
  color: #1d4f91;
}

.caixa_produtos {
  margin-bottom: 1rem;
}

.imgCategoria {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 300px;
}

.item_produto {
  cursor: pointer;
}

.item_produto .disabled {
  display: none !important;
  background: #cacaca;
  border-color: #cacaca;
}

.item_produto .tagEsgotado {
  background-color: var(--cor-secundaria);
  color: #fff;
  padding: 4px 32px;
  border-radius: 50px 0 0 50px;
  margin: 0 16px;
  position: absolute;
  z-index: 1;
  right: 0;
  display: none;
}

.item_produto.esgotado .tagEsgotado {
  display: initial;
}

.item_produto.esgotado .disabled {
  display: block !important;
}

.item_produto.esgotado .btn_selecionar:not(.disabled) {
  display: none !important;
}

.item_produto .btn_selecionar {
  font-size: x-small;
}

.item_produto.esgotado .valor *,
.item_produto.esgotado span {
  color: #cacaca !important;
}

.item_produto.esgotado .titulo_categoria {
  filter: opacity(0.3);
}

.lista_produtos .item_produto .titulo_categoria {
  font-weight: 400;
  font-size: 18px;
}
</style>
